import { render, staticRenderFns } from "./AppBnc.vue?vue&type=template&id=4ae89196&"
import script from "./AppBnc.vue?vue&type=script&lang=js&"
export * from "./AppBnc.vue?vue&type=script&lang=js&"
import style0 from "./AppBnc.vue?vue&type=style&index=0&id=4ae89196&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports